import React, { useState } from "react";
import { SearchProvider, SearchBox } from "@elastic/react-search-ui";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import config from "./config";
import appConfig from "../config";

const drupalFilePath =
  appConfig.filePath + "react-app-images/SearchBar_Icn.png";

export default function App() {
  const navigate = (searchText) => {
    if (searchText) {
      const redirectUrl = `${appConfig.keywordSearchAppUrl}?q=${searchText}`;
      window.location.href = redirectUrl;
    }
  };

  const [text, setText] = useState("");

  return (
    <SearchProvider config={config}>
      <SearchBox
        autocompleteSuggestions={true}
        inputView={({ getAutocomplete, getInputProps, getButtonProps }) => (
          <>
            <div className="l-inner">
              <div className="l-header-search__input j-input">
                <label htmlFor="header-search">Search keyword here</label>
                <input
                  {...getInputProps({
                    placeholder: "Search keyword here",
                    id: "header-search",
                    type: "text",
                    autoComplete: "off",
                  })}
                />
                {getAutocomplete()}
                <div className="l-header-search__icon">
                  <label htmlFor="dosearch"></label>
                  <input
                    id="dosearch"
                    type="image"
                    src={drupalFilePath}
                    alt="Website Search Bar icon"
                  />
                </div>
              </div>
              <button className="l-header-search__close"></button>
            </div>
          </>
        )}
        onSubmit={(searchTerm) => {
          navigate(searchTerm);
        }}
        onSelectAutocomplete={(selection, {}, defaultOnSelectAutocomplete) => {
          if (selection.suggestion) {
            navigate(selection.suggestion);
          } else {
            defaultOnSelectAutocomplete(selection);
          }
        }}
      />
    </SearchProvider>
  );
}
